import React from 'react';
import { useQuery } from '@apollo/client';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';
import { CloudSiteLink, NoData } from '@css-xp/ppc-common';
import { fetchEntitlementDetailsForOrderHistoryPPC } from '../queries/fetch-entitlement-details-by-id';
import {
  FetchEntitlementDetailsForOrderHistoryPpcQuery,
  FetchEntitlementDetailsForOrderHistoryPpcQueryVariables,
} from '@css-xp/graphtypes/src/generated-types-new';

export interface CloudSiteCellProps {
  entitlementId: string;
  transactionAccountId?: string;
}

export const CloudSiteCell = ({ entitlementId, transactionAccountId }: CloudSiteCellProps) => {
  const { data, loading, error } = useQuery<
    FetchEntitlementDetailsForOrderHistoryPpcQuery,
    FetchEntitlementDetailsForOrderHistoryPpcQueryVariables
  >(fetchEntitlementDetailsForOrderHistoryPPC, {
    variables: {
      id: entitlementId,
      transactionAccountId: transactionAccountId,
    },
    skip: !entitlementId,
    nextFetchPolicy: 'cache-and-network',
  });
  const entitlementDetails = data?.entitlementDetails;

  if (loading) {
    return (
      <td>
        <SkeletonLoaderWrapper>
          <SkeletonLoader width="60%" marginBottom="0" />
        </SkeletonLoaderWrapper>
      </td>
    );
  }

  if (error || !entitlementId || !entitlementDetails?.cloudSiteId) {
    return (
      <td>
        <NoData />
      </td>
    );
  }

  return (
    <td>
      <CloudSiteLink
        siteName={entitlementDetails?.cloudSiteHostname}
        txaId={transactionAccountId}
        cloudSiteId={entitlementDetails?.cloudSiteId}
      />
    </td>
  );
};
